export const messages = {
    userUpdated: 'Your profile has been saved successfully.',
    netBanking : 'Net Banking',
    checkIsDomestic : 'check_isDomestic', // command to check whether a card is domestic or not
    getIssuingBankStatus : 'getIssuingBankStatus', // command to check whether the bank is up for net banking
    getNetbankingStatus : 'getNetbankingStatus', // command to get all the available banks in payu
    cancelled : "CANCELLED",
    closed : "CLOSED"
};
export const DateTimeFormats = {
    defaultDateFormat: 'DD-MM-YYYY',
    dateTimeFormatdmyhms: 'DD/MM/YYYY HH:mm:ss',
    dateTimeFormatymdthms : 'YYYY-MM-DDTHH:mm:ss.SSS'
};